import React from "react";
import Container from "../../../share/atoms/container/index";
import { Wrapper, Wrap } from "./styles";
import { useResize } from "share/hooks/useResize";
import { getCustomHeight } from "./helper";
import TermsHeader from "share/organisms/headers/terms-header";
import { StyledHeader } from "../TermsAndConditions/styles";

const PrivacyPolicyPage = (props) => {
  const { width, height: screenHeight } = useResize();
  return (
    <>
      <div style={{ backgroundColor: "#F3F6FF" }}>
        {!props.isHome && <TermsHeader />}
        <Wrap>
          <Container>
            <Wrapper style={{ marginBottom: "100px" }}>
              <StyledHeader>Privacy Policy</StyledHeader>
              <div style={{ overflowY: "scroll" }}>
                <iframe
                  id="iframe"
                  width="100%"
                  style={{
                    height: getCustomHeight(screenHeight),
                    border: "none"
                  }}
                  src="https://neap-sandbox.s3.ap-south-1.amazonaws.com/FE-assets/privacy-and-policy-neap.html"
                  title="privacy-policy"
                />
                {/* {getDeleteButton()} */}
              </div>
            </Wrapper>
          </Container>
        </Wrap>
      </div>
    </>
  );
};
export default PrivacyPolicyPage;
